import React, { useEffect } from 'react';
import { Route, RouteProps } from 'react-router';

import { entityReset } from '@uncinc/react-drupal-core';

import useTypedDispatch from '../../helpers/useDispatch';

const CustomRoute: React.FC<RouteProps> = (props) => {
  const dispatch = useTypedDispatch();

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => () => {
    dispatch(entityReset());
  });

  return (
    <Route {...props} />
  );
};

export default CustomRoute;
